import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: 3
};
import { indexMethod } from '@/utils/indexMethod';
export default {
  __name: 'Table',
  props: {
    schemas: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 8
    }
  },
  emits: ['del', 'data', 'update', 'info', 'changeStatus', 'auth'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const handleUpdate = row => {
      emits('update', row);
    };
    const handleDel = row => {
      emits('del', row);
    };
    const handleInfo = row => {
      emits('info', row);
    };
    const handleStatusChange = (row, val) => {
      emits('changeStatus', {
        ...row,
        accountStatus: val ? 1 : 0
      });
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.tableData,
        style: {
          "width": "100%"
        },
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.currentPage, __props.pageSize),
          align: "center",
          "min-width": 30
        }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schemas, (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: item.label,
            "min-width": item.minWidth,
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [item.prop === 'createTime' ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$filters.dateFilter(row[item.prop])), 1)) : item.prop === 'accountStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_switch, {
              modelValue: row[item.prop] == 1,
              "active-text": "开通",
              "inactive-text": "关闭",
              onChange: val => handleStatusChange(row, val)
            }, null, 8, ["modelValue", "onChange"])])) : item.prop === 'action' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.btnArr, (item, index) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: index
              }, [item === 'info' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                size: "small",
                onClick: $event => handleInfo(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 详情 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'update' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                size: "small",
                onClick: $event => handleUpdate(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'delete' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "danger",
                size: "small",
                onClick: $event => handleDel(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(row[item.prop]), 1))]),
            _: 2
          }, 1032, ["label", "min-width"]);
        }), 128))]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]]);
    };
  }
};